import React, { Component } from "react";
import { withStyles } from "material-ui/styles";

import { DropTarget } from "react-dnd";
import { fade } from "material-ui/styles/colorManipulator";
import Icon from "material-ui/Icon";
import getDndContext from "components/DndContext";
import Item from "./Item";
import ItemTypes from "./ItemTypes";

const styles = {
  addButton: {
    border: "1px dashed gray",
    padding: "0.5rem 1rem",
    marginBottom: ".5rem",
    backgroundColor: "white",
    cursor: "pointer",
    outline: "none",
    "&:hover": {
      backgroundColor: fade("#26a69a", 0.1),
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  }
};

const itemTarget = {
  drop() {}
};

const dropTarget = connect => ({
  connectDropTarget: connect.dropTarget()
});

class Container extends Component {
  moveItem(id, atIndex) {
    const { index } = this.findItem(id);
    this.props.changeItemOrder(index, atIndex);
  }

  findItem(id) {
    const { items, localeNo } = this.props;
    const item = items[localeNo].filter(c => c.id === id)[0];

    return {
      item,
      index: items[localeNo].indexOf(item)
    };
  }
  addButton(showAdd, addNewItem, isEdit, classes) {
    if (showAdd && isEdit) {
      return (
        <div
          role="button"
          id="addButton"
          tabIndex={0}
          onClick={() => addNewItem()}
          onKeyPress={() => addNewItem()}
          className={classes.addButton}
          style={{ textAlign: "center" }}
        >
          <Icon style={{ verticalAlign: "sub", fontSize: 20 }}>add</Icon>
          <span>（追加）</span>
        </div>
      );
    }
    return null;
  }

  itemsButtons(
    items,
    localeNo,
    selectedItemId,
    movable,
    isEdit,
    classes,
    additionMode
  ) {
    return (
      <div>
        {items[localeNo] &&
          items[localeNo].map((item, i) => (
            <Item
              key={item.id}
              id={item.id}
              index={additionMode ? i + 64 : i + 1}
              title={item.title}
              isSelected={item.id - selectedItemId === 0}
              selectItem={this.props.selectItem}
              findItem={id => this.findItem(id)}
              moveItem={(id, index) => this.moveItem(id, index)}
              movable={movable}
              isEdit={isEdit}
              classes={classes}
            />
          ))}
      </div>
    );
  }

  render() {
    const {
      connectDropTarget,
      selectedItemId,
      movable,
      items,
      localeNo,
      showAdd,
      addNewItem,
      classes,
      isEdit,
      additionMode,
      maxItemCount
    } = this.props;

    return (
      <div>
        {movable && isEdit
          ? connectDropTarget(
              this.itemsButtons(
                items,
                localeNo,
                selectedItemId,
                movable,
                isEdit,
                classes,
                additionMode
              )
            )
          : this.itemsButtons(
              items,
              localeNo,
              selectedItemId,
              movable,
              isEdit,
              classes,
              additionMode
            )}
        {items[localeNo] &&
          maxItemCount > 0 &&
          items[localeNo].length < maxItemCount &&
          this.addButton(showAdd, addNewItem, isEdit, classes)}
      </div>
    );
  }
}

export default getDndContext()(
  DropTarget(ItemTypes.ITEM, itemTarget, dropTarget)(
    withStyles(styles)(Container)
  )
);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/BaseWord/Container.jsx